import React from 'react';

export default function BackpackSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      {/* Straps */}
      <line x1="13" y1="8" x2="13" y2="18" stroke="#5A8A3A" strokeWidth="2" strokeLinecap="round" />
      <line x1="27" y1="8" x2="27" y2="18" stroke="#5A8A3A" strokeWidth="2" strokeLinecap="round" />
      {/* Main bag body */}
      <rect x="10" y="10" width="20" height="24" rx="4" fill="#6AAA44" />
      {/* Bag shadow / depth */}
      <rect x="12" y="12" width="16" height="20" rx="3" fill="#5A9A3A" />
      {/* Front pocket */}
      <rect x="14" y="22" width="12" height="10" rx="2" fill="#7BBB55" />
      <rect x="15" y="23" width="10" height="8" rx="1.5" fill="#6AAA44" />
      {/* Pocket flap */}
      <path d="M14 22C14 22 18 24 20 24C22 24 26 22 26 22" stroke="#5A9A3A" strokeWidth="1" fill="none" />
      {/* Pocket button */}
      <circle cx="20" cy="27" r="1.2" fill="#D4A830" />
      {/* Top flap */}
      <path d="M10 14C10 12 12 10 20 10C28 10 30 12 30 14" stroke="#5A9A3A" strokeWidth="1.5" fill="none" />
      {/* Zipper line */}
      <line x1="14" y1="16" x2="26" y2="16" stroke="#D4A830" strokeWidth="0.8" />
      <circle cx="26" cy="16" r="1" fill="#D4A830" />
      {/* Handle */}
      <path d="M17 8C17 5 23 5 23 8" stroke="#5A8A3A" strokeWidth="2" strokeLinecap="round" fill="none" />
    </svg>
  );
}
